import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ParsedNewsData, WeaveNews } from '@shared/model/newsdata.model';
import { NewsroomService } from '@shared/services';
import { DomSanitizer, Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-news-detail',
  templateUrl: './news-detail.component.html',
  styleUrls: ['./news-detail.component.scss'],
})
export class NewsDetailComponent implements OnInit {
  detail: WeaveNews;
  currentLang = '';

  constructor(
    private activatedRoute: ActivatedRoute,
    private newsService: NewsroomService,
    private translateService: TranslateService,
    private title: Title,
    private meta: Meta,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.currentLang = this.translateService.currentLang;
    this.translateService.onLangChange.subscribe((event) => {
      this.currentLang = event.lang;

      if (this.detail) {
        this.title.setTitle(`Weave -
          ${
            this.currentLang === 'id'
              ? this.detail.parsed_title.id
              : this.detail.parsed_title.en
          }
        `);
      }
    });

    this.activatedRoute.paramMap.subscribe((params) => {
      this.newsService
        .getWeaveNewsDetail(params.get('slug'))
        .then((res: any) => {
          if (res) {
            const news: WeaveNews = res.data;
            this.detail = {
              ...news,
              created_at: new Date(news.created_at),
              parsed_content: this.customParse(news.content),
              parsed_meta_desc: JSON.parse(news.meta_desc),
              parsed_meta_tag: JSON.parse(news.meta_tag),
              parsed_meta_title: JSON.parse(news.meta_title),
              parsed_og_desc: JSON.parse(news.og_desc),
              parsed_og_title: JSON.parse(news.og_title),
              parsed_short_desc: JSON.parse(news.short_desc),
              parsed_title: JSON.parse(news.title),
            };

            this.title.setTitle(`Weave -
              ${
                this.currentLang === 'id'
                  ? this.detail.parsed_title.id
                  : this.detail.parsed_title.en
              }
            `);

            this.meta.updateTag({
              name: 'keywords',
              content: this.detail.parsed_meta_tag.en,
            });

            this.meta.updateTag({
              name: 'description',
              content: this.detail.parsed_meta_desc.en,
            });

            this.meta.updateTag({
              property: 'og:title',
              content: this.detail.parsed_og_title.en,
            });

            this.meta.updateTag({
              property: 'og:description',
              content: this.detail.parsed_og_desc.en,
            });

            this.meta.updateTag({
              name: 'twitter:title',
              content: this.detail.parsed_og_title.en,
            });

            this.meta.updateTag({
              name: 'twitter:description',
              content: this.detail.parsed_og_desc.en,
            });
          }
        });
    });
  }

  customParse(data: string): ParsedNewsData {
    const json: ParsedNewsData = JSON.parse(data);
    json.sanitized_en = this.sanitizer.bypassSecurityTrustHtml(json.en);
    json.sanitized_id = this.sanitizer.bypassSecurityTrustHtml(json.id);

    return json;
  }
}
